import { SCOPES_TITLE, TIER_SCOPES } from '../TierConsts';

const InScopeBadge = () => {
    return (
        <div
            className={`h-6 px-2 items-center content-center rounded w-fit text-sm font-medium flex gap-2 bg-sf-positive-100`}>
            <div className="text-[#00B283]">{SCOPES_TITLE[TIER_SCOPES.IN_SCOPE]}</div>
        </div>
    );
};

export default InScopeBadge;
